module.exports = __webpack_public_path__ + "media/metronic/_theme/media/blog/blog3-3ff9ecd4c83c1125137fb97943750486.jpg";